import { Grid, Box, Typography, Container } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const DefaultPrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <div className="footer-document-content">
      <p>
        <b>{t("privacy-policy.heading")}</b>
      </p>
      <p>
       {t("privacy-policy.line-1")}
      </p>
      <p>
        {t("privacy-policy.line-2")}
      </p>
      <p>
        <b>{t("privacy-policy.line-3")}</b>
      </p>
      <p>
        {t("privacy-policy.line-4")}
      </p>
      <p>
        {t("privacy-policy.line-5")}
      </p>
      <p>
        {t("privacy-policy.line-6")}
      </p>
      <p>{t("privacy-policy.line-7")}</p>
      <p>{t("privacy-policy.line-8")}</p>
      <p>
        <b>
          {t("privacy-policy.line-9")}
        </b>
      </p>
      <p>
        {t("privacy-policy.line-10")}
      </p>
      <p>
        <b>1. {t("privacy-policy.line-11")}</b>
      </p>
      <p>
        {t("privacy-policy.line-12")}
      </p>
      <ul>
        <li>{t("privacy-policy.line-13")}</li>
        <li>{t("privacy-policy.line-14")}</li>
        <li>{t("privacy-policy.line-15")}</li>
        <li>{t("privacy-policy.line-16")}</li>
        <li>{t("privacy-policy.line-17")}</li>
        <li>
          {t("privacy-policy.line-18")}
        </li>
        <li>
          {t("privacy-policy.line-19")}
        </li>
        <li>{t("privacy-policy.line-20")}</li>
      </ul>
      <p>
        {t("privacy-policy.line-21")}
      </p>
      <ul>
        <li>
          {t("privacy-policy.line-22")}
        </li>
        <li>{t("privacy-policy.line-23")}</li>
        <li>{t("privacy-policy.line-24")}</li>
        <li>{t("privacy-policy.line-25")}</li>
      </ul>
      <p>
        {t("privacy-policy.line-26")}
      </p>
      <p>
        {t("privacy-policy.line-27")}
      </p>
      <p>
        <b>2. {t("privacy-policy.line-28")}</b>
      </p>
      <p>
        {t("privacy-policy.line-29")}
      </p>
      <p>
        {t("privacy-policy.line-30")}
      </p>
      <p>
        {t("privacy-policy.line-31")}
      </p>
      <p>
        {t("privacy-policy.line-32")}
      </p>
      <p>
        {t("privacy-policy.line-33")}
      </p>
      <p>
        {t("privacy-policy.line-34")}
      </p>
      <p>
        <b>4. {t("privacy-policy.line-35")}</b>
      </p>
      <p>{t("privacy-policy.line-36")}</p>
      <p>
        {t("privacy-policy.line-37")}
      </p>
      <p>
        {t("privacy-policy.line-38")}
      </p>
      <p>
        {t("privacy-policy.line-39")}
      </p>
      <p>
        {t("privacy-policy.line-40")}
      </p>
      <p>
        <b>{t("privacy-policy.line-41")}</b>
      </p>
      <p>1.</p>
      <p>
        {t("privacy-policy.line-42")}
      </p>
      <p>{t("privacy-policy.line-43")}</p>
      <ul>
        <li>
        {t("privacy-policy.line-44")}
        </li>
        <li>
        {t("privacy-policy.line-45")}
        </li>
        <li>
        {t("privacy-policy.line-46")}
        </li>
        <li>
        {t("privacy-policy.line-47")}
        </li>
      </ul>
      <p>
        {t("privacy-policy.line-48")}
      </p>
      {/* <p>2.</p>
      <p>{t("privacy-policy.line-49")}</p>
      <p>
        {t("privacy-policy.line-50")}
      </p>
      <p>
        {t("privacy-policy.line-51")}
        <a
          target={"_blank"}
          style={{ color: "black !important" }}
          href=" https://www.vr-payment.de/datenschutz-haftung-in-app-zahlmodul-nutzer/"
        >
          {" "}
          https://www.vr-payment.de/datenschutz-haftung-in-app-zahlmodul-nutzer/
        </a>
      </p> */}
      <p>
      <b>{t("privacy-policy.line-52")}</b>
      </p>
      <p>{t("privacy-policy.line-53")}</p>
      <ul>
        <li>
        {t("privacy-policy.line-54")}
        </li>
        <li>
        {t("privacy-policy.line-55")}
        </li>
        <li>
        {t("privacy-policy.line-56")}
        </li>
        <li>
       {t("privacy-policy.line-57")}
        </li>
        <li>
        {t("privacy-policy.line-58")}
        </li>
        <li>
        {t("privacy-policy.line-59")}
        </li>
      </ul>
      <p>
        <b>{t("privacy-policy.line-60")}</b>
      </p>
      <p>
        
          {t("privacy-policy.line-61")}
        
      </p>
      <p>
       
          {t("privacy-policy.line-62")}
       
      </p>
      <p>
        <b>{t("privacy-policy.line-63")}</b>
      </p>
      <p>
        {t("privacy-policy.line-64")}
      </p>
      <p>
        <b>{t("privacy-policy.line-65")}</b>
      </p>
      <p>{t("privacy-policy.line-66")}</p>
      <p>
        {t("privacy-policy.line-67")}
      </p>
    </div>
  );
};

export default DefaultPrivacyPolicy;
